import { http } from '../http';
import { consoleSerializer } from '@/providers/serializers/console/console';
import { authSerializer } from '@/providers/serializers/auth/auth';
import { PartnersModel } from '@/models/console/partners';

/**
 * ConsoleAPI help to handle all the API that are used under console page
 */
export class ConsoleAPI {

    private static INSTANCE = new ConsoleAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/missioncontrol/v1';

    public getImpersonateUsersList(
        searchFilter: { offet: number, limit: number, filterBy?: string, query?: string}) {
        const endpoint = `${this.namespace}/admin/users/search`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, searchFilter).then((response) => {
            return consoleSerializer.impersonateUserListSerialzer(response.data);
        });
    }

    public fetchNaigatorUsersList(
        searchFilter: { offet: number, limit: number, filterBy?: string, query?: string}) {
        const endpoint = `${this.namespace}/admin/navigator/users/search`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, searchFilter).then((response) => {
            return consoleSerializer.impersonateUserListSerialzer(response.data);
        });
    }


    public getImpersonateLogin(userId: string) {
        const endpoint = `${this.namespace}/admin/impersonate/${userId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return authSerializer.sessionModelSerializer(response.data);
        });
    }

    public impersonateNavigator(userId: string) {
        const endpoint = `${this.namespace}/admin/navigator/impersonate/${userId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return authSerializer.sessionModelSerializer(response.data);
        });
    }

    public fetchPartnerList() {
        const endpoint = `${this.namespace}/partners`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return response.data;
        });
    }

    public fetchModifiedPartnerList() {
        const endpoint = `${this.namespace}/partners`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return authSerializer.modifiedPartnerListSerializer(response.data);
        });
    }

    public fetchModifiedConentProviderPartnerList() {
        const endpoint = `${this.namespace}/partners`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return authSerializer.modifiedConentProviderPartnerListSerializer(response.data);
        });
    }

    public fetchPartnerByType(params: any) {
        const endpoint = `${this.namespace}/partners`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return response.data;
        });
    }

    public insertPartner(data: PartnersModel) {
        const endpoint = `${this.namespace}/partner`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, data).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updatePartner(data: PartnersModel, partnerId: string) {
        const endpoint = `${this.namespace}/partner/${partnerId}`;
        const headers = http.getTokenHeaders();
        return http.put(endpoint, headers, data).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public fetchPartnerDetails(partnerId: string) {
        const endpoint = `${this.namespace}/partners/${partnerId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return consoleSerializer.normalizePartnerDetails(response.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

}

export const consoleAPI = ConsoleAPI.instance;
